import moment from "moment";
import { getEnvName } from "../constants/Configs";

export const getDateToMomentISOString = (date?: Date): string => {
  const dateObj = date || new Date();
  return moment(dateObj).toISOString();
};

export const isValidObject = (input: any) => {
  return !(input === undefined || input === null);
};